import compniesDetailController from '../companies-detail/companies-detail.controller';

class companiesUpdateController extends compniesDetailController{
  /**
   *
   * @param $companies
   * @param $stateParams
   * @param CONFIG
   */
  constructor(
    $companies,
    $stateParams,
    CONFIG
  ){
    'ngInject';
    super(...arguments);
  }

  $onSubmit(){
    delete this.data.sub;
    this.$companies.update( this.config.id , this.data );
  }

}

export default companiesUpdateController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-update/companies-update.controller.js
 **/